const aifJcamp2 = `
##TITLE=Spectrum
##JCAMP-DX=5.00 $$ chemotion-converter-app (0.1.0)
##DATA TYPE=SORPTION-DESORPTION MEASUREMENT
##DATA CLASS=XYDATA
##ORIGIN=
##OWNER=
##XUNITS=p/p0
##YUNITS=ml/g
##OPERATOR=Volodymyr
##DATE=2020-04-30T00:00:00
##SERIAL=BEL 00218
##ADSORPTIVE=CH4
##AMOUNT=0.00980
##SAMPLE_CID=aus der BOX
##SAMPLE_MAT_ID=DUT-140(Cu)
##SOFTWARE=raw2aif
##SOFTWARE_VERSION=v004
##FIRSTX=0.9562025066614033
##LASTX=0.0013190565479127604
##MINX=0.0013190565479127604
##MAXX=0.9562025066614033
##MINY=383.81
##MAXY=1479.7
##NPOINTS=82
##FIRSTY=1479.7
##XUNITS=p/p0
##YUNITS=ml/g
##XYDATA=(XY..XY)
0.9562025066614033, 1479.7
0.9443106681140827, 1477.3
0.9321819796703839, 1475.6
0.9204480410539821, 1472.5
0.9083588275930129, 1469.0
0.8962696141320439, 1465.6
0.8837757820980954, 1462.7
0.8719234185335044, 1459.8
0.8599131550379947, 1456.7
0.8474193230040462, 1454.9
0.8352906345603474, 1452.7
0.8232310273364256, 1449.4
0.8112602388236455, 1446.8
0.7988947004835686, 1444.5
0.7868350932596467, 1441.8
0.7746274548504885, 1439.6
0.7625382413895194, 1438.1
0.7503996842001381, 1435.6
0.7383894207046284, 1432.6
0.7260633573472812, 1430.5
0.7139248001578999, 1428.5
0.7020329616105793, 1427.2
0.6899042731668805, 1426.8
0.6789006217309781, 1424.4
0.664995559064443, 1422.2
0.6509819401954011, 1420.1
0.6373630711536564, 1417.9
0.623379058521662, 1415.6
0.6097996644626468, 1413.5
0.5956577518997336, 1411.1
0.5819599328925293, 1408.7
0.5679857890062173, 1406.1
0.5540807263396823, 1403.4
0.5401460574360999, 1400.6
0.5263199447350242, 1397.8
0.5124247508141715, 1394.8
0.49864798184150794, 1392.3
0.48498963781703347, 1388.9
0.4709661502023093, 1386.0
0.45703148129872695, 1382.9
0.44316589361492154, 1379.9
0.42934964965952827, 1376.6
0.4154939307214053, 1372.9
0.4016283430376, 1369.5
0.38781209908220665, 1365.7
0.3739563801440837, 1361.6
0.3600118424948189, 1357.8
0.34627454850488504, 1353.7
0.33229053587289054, 1349.8
0.3185927168656864, 1345.5
0.3047369979275634, 1340.4
0.28991414191256293, 1335.0
0.27569327938419025, 1329.6
0.26235073522155333, 1324.0
0.24861344123161946, 1317.6
0.23503404717260434, 1310.7
0.22129675318267047, 1302.6
0.20763840915819598, 1293.8
0.19478930227968025, 1284.5
0.1684298825619264, 1242.6
0.1667818020329616, 1235.8
0.15903483667225896, 1176.6
0.1511990526004145, 1093.3
0.14665942958649955, 1030.0
0.14400473699792757, 986.68
0.14155728806868648, 942.29
0.1387841705319254, 870.19
0.13701766505477153, 816.27
0.13480706602190862, 742.71
0.13319846047567355, 683.09
0.1316391986578506, 633.49
0.1289845060692786, 581.11
0.1115859074311655, 544.44
0.09708773314911674, 537.71
0.08266554820882266, 533.49
0.0688868054870226, 529.35
0.05518799960525017, 524.71
0.04177045297542682, 518.59
0.00863692884634363, 482.67
0.003195993289252936, 448.59
0.0018709168064738972, 415.76
0.0013190565479127604, 383.81
##END=$$ End of the data block


`;

export default aifJcamp2;
